import State from "./Select.state/Select.state"
import Country from "./Select.country/Select.country"
import JapanPrefecture from "./Select.japan.prefecture/Select.japan.precture"
import ChinaProvince from "./Select.china.province/Select.China.province"
import VietnamProvince from "./Select.vietnam.province/Select.vietnam.province"
import ThailandProvince from "./Select.thailand.province/Select.thailand.province"
import MalaysiaState from "./Select.malaysia.state/Select.malaysia.state"
import CambodiaProvince from "./Select.cambodia.province/Select.cambodia.province"

const MantineSelect:any = {
    State,
    Country,
    JapanPrefecture,
    ChinaProvince,
    VietnamProvince,
    ThailandProvince,
    MalaysiaState,
    CambodiaProvince
}

export default MantineSelect;